import React, { memo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Stack, Tabs, Tab, Button, Icon } from 'investira.react.components';
import { BaseTemplate } from '../../../components/templates';
import withMessage from '../../../hoc/withMessage';
import ModelosSettings from './_settings/ModelosSettings';
import SecoesSettings from './_settings/SecoesSettings';
import QuestoesSettings from './_settings/QuestoesSettings';

const OPTIONS = {
  modelos: {
    id: 'modelos',
    label: 'Modelos',
    value: 0,
    addButtonLabel: 'Novo Modelo',
    component: ModelosSettings
  },
  questoes: {
    id: 'questoes',
    label: 'Questões',
    value: 1,
    addButtonLabel: 'Nova Questão',
    component: QuestoesSettings
  },
  secoes: {
    id: 'secoes',
    label: 'Seções',
    value: 2,
    addButtonLabel: 'Nova Seção',
    component: SecoesSettings
  }
};

const AvaliacoesSettings = memo(props => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const xCurrentOptions = OPTIONS[params.output];
  const SettingsComponent = xCurrentOptions.component;
  const xOptions = Object.values(OPTIONS);

  return (
    <BaseTemplate title={'Configurações'} subtitle={'Avaliações'} maxWidth={'xl'}>
      <Stack gap={4}>
        <Stack sx={{ minWidth: '200px' }}>
          <Tabs
            value={OPTIONS[params.output].value}
            onChange={(event, pNewValue) => {
              navigate(`${location.pathname.replace(/\/[^/]*$/, '')}/${xOptions[pNewValue].id}`);
            }}
            variant="scrollable"
            sx={{ borderBottom: 1, borderColor: 'divider', textAlign: 'left' }}>
            {xOptions.map(xOption => {
              return (
                <Tab
                  key={xOption.id}
                  label={xOption.label}
                  sx={{ textAlign: 'right', alignItems: 'end' }}
                />
              );
            })}
          </Tabs>
        </Stack>
        <Stack>
          <Stack>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
              <Button
                variant="contained"
                size="small"
                component="button"
                onClick={() => {
                  navigate(`${location.pathname}/add`);
                }}
                startIcon={<Icon iconName="insert" size={16} />}>
                {OPTIONS[params.output].addButtonLabel}
              </Button>
            </Stack>
          </Stack>
          <SettingsComponent {...props} />
        </Stack>
      </Stack>
    </BaseTemplate>
  );
});

AvaliacoesSettings.displayName = 'AvaliacoesSettings';

export default withMessage(AvaliacoesSettings);
